export default [
  {
    path: '/campaigns',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: "campaigns-list" */ "@/views/campaigns/List.vue"),
  },
  {
    path: '/campaigns/new',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: "campaigns-create" */ "@/views/campaigns/Create.vue"),
  },
  {
    path: '/campaigns/:id',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: "campaign" */ "@/views/campaigns/Campaign.vue"),
  }
]
